// please update same key value in backend for recommendedWeeklyUserMeeting.php
export const RECOMMENDEDMATCH = {
  NO_RECOMMENDED_MATCH: "no-recommended-match",
  DAILY_CONNECTION_MATCH: "daily-connection-match",
  WEEKLY_CONNECTION_MATCH: "weekly-connection-match",
  MONTHLY_CONNECTION_MATCH: "monthly-connection-match"
}